import { Card } from '../card';
import { LessonFamily } from '../lesson-family';
import { School } from '../school';
import { Student } from '../student';

export class ReservationFamily {
    constructor(
        public id?: number,
        public school?: School,
        public startDate?: any,
        public endDate?: any,
        public student?: Student,
        public card?: Card,
        public lessonFamily?: LessonFamily
    ) {
    }
}

export class ReservationFamilyWithContextDetails extends ReservationFamily {
    totalReservations: number;

    /**
     * Converts a plain ReservationFamily into ReservationFamilyWithContextDetails
     */
    public static fromReservationFamily(reservationFamily: ReservationFamily): ReservationFamilyWithContextDetails {
        const enriched = new ReservationFamilyWithContextDetails(
            reservationFamily.id,
            reservationFamily.school,
            reservationFamily.startDate,
            reservationFamily.endDate,
            reservationFamily.student,
            reservationFamily.card,
            reservationFamily.lessonFamily);

        enriched.totalReservations = 0;

        return enriched;
    }

}


export class ReservationFamilyBulkCreateInput {
    constructor(
        public idempotencyKey: string,
        public cardIds: number[],
        public lessonFamilyIds: number[]
    ) {
    }
}

export class ReservationFamilyBulkCreateBackgroundJobResult {
    constructor(
        public idempotencyKey: string,
        public status: string
    ) {
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/reservation-family/reservation-family.model.ts